import React, { useCallback, useEffect, type FC } from 'react'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import { notifyParent } from 'mailup-react-helpers'
import { Flex, ToastContainer, Tooltip } from 'mailup-web-components'

import Page from 'Containers/Page'

import BoxResults from 'Pages/UnsubscriptionCampaignsList/components/BoxResults'
import CannotCreateMessage from 'Pages/UnsubscriptionCampaignsList/components/CannotCreateMessage'
import EmptyStateMessage from 'Pages/UnsubscriptionCampaignsList/components/EmptyStateMessage'
import Header from 'Pages/UnsubscriptionCampaignsList/components/Header'
import Info from 'Pages/UnsubscriptionCampaignsList/components/Info'
import ModalActivateSimulate from 'Pages/UnsubscriptionCampaignsList/components/ModalActivateSimulate'
import ModalCopy from 'Pages/UnsubscriptionCampaignsList/components/ModalCopy'
import ModalDelete from 'Pages/UnsubscriptionCampaignsList/components/ModalDelete'
import ModalSimulate from 'Pages/UnsubscriptionCampaignsList/components/ModalSimulate'

import { modalActivateSimulateCloseCallback } from 'Pages/UnsubscriptionCampaignsList/recoil/callbacks/modals'
import {
  activateCallback,
  fetchResultsCallback,
  resetPageCallback,
} from 'Pages/UnsubscriptionCampaignsList/recoil/callbacks/results'
import { modalActivateSimulateState } from 'Pages/UnsubscriptionCampaignsList/recoil/state/modals'
import { emptyStateState } from 'Pages/UnsubscriptionCampaignsList/recoil/state/results'

const UnsubscriptionCampaignsList: FC = () => {
  const isEmptyState = useRecoilValue(emptyStateState)

  const modalActivateSimulate = useRecoilValue(modalActivateSimulateState)

  const fetchResults = useRecoilCallback(fetchResultsCallback, [])
  const resetPage = useRecoilCallback(resetPageCallback, [])

  const activate = useRecoilCallback(activateCallback, [])

  const modalActivateSimulateClose = useRecoilCallback(
    modalActivateSimulateCloseCallback,
    [],
  )

  const handleEdit = useCallback(() => {
    const route = `/automation/workflow/${modalActivateSimulate.idWorkflow}/edit`
    notifyParent('redirectMainFrame', [
      `automation_app_redirector.aspx?r=${encodeURIComponent(route)}`,
    ])
  }, [modalActivateSimulate.idWorkflow])

  const handleActivate = useCallback(() => {
    void activate(modalActivateSimulate.idWorkflow)
  }, [modalActivateSimulate.idWorkflow, activate])

  const init = (): void => {
    void fetchResults({ pageNumber: 1, pageSize: 10 }, true)
  }

  useEffect(() => {
    init()

    return (): void => {
      void resetPage()
    }
  }, [])

  return (
    <>
      <Tooltip />
      <ToastContainer />

      <ModalCopy />
      <ModalSimulate />
      <ModalDelete />

      <ModalActivateSimulate
        show={modalActivateSimulate.show}
        mode={modalActivateSimulate.mode}
        recipientLimit={modalActivateSimulate.recipientLimit}
        onClose={modalActivateSimulateClose}
        onEdit={handleEdit}
        onActivate={handleActivate}
        idWorkflow={modalActivateSimulate.idWorkflow}
      />

      <Header />
      <Page onReload={init}>
        <Flex flexDirection="column" gap="16px">
          <Info />
          {isEmptyState ? <EmptyStateMessage /> : <BoxResults />}
          <CannotCreateMessage />
        </Flex>
      </Page>
    </>
  )
}

export default UnsubscriptionCampaignsList
